module.exports = __webpack_public_path__ + "static/media/scr_date_picker.195bd597.png";